import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import React, { ComponentProps, CSSProperties, FunctionComponent } from 'react'

interface VerticalSegmentProps {
  className?: string
  id?: string
  text?: boolean
  style?: Partial<CSSProperties>
}

/**
 * Helper component that wraps stuff in the ubiquitous `.ui.vertical.segment+.ui.container combo.`
 *
 * @param {ComponentProps<FunctionComponent<VerticalSegmentProps>>} props
 * @param {string=''} props.className - Classes to be passed to the segment wrapper.
 * @param {boolean=false} props.text - Whether the container should be rendered in text width.
 * @param {ReactChildren} props.children
 */
export const VerticalSegment: FunctionComponent<VerticalSegmentProps> = ({
  className = '',
  id = '',
  style = {},
  text = false,
  children
}: ComponentProps<typeof VerticalSegment>) => (
  <div id={id} className={`ui vertical segment ${className}`} style={style}>
    <div className={`ui ${text ? 'text' : ''} container`}>{children}</div>
  </div>
)
